export type ValueOf<T> = T[keyof T];

export const VOLTAGE = Object.freeze({
  VOLTAGE_400: 400,
  VOLTAGE_230: 230,
  VOLTAGE_110: 110
})

export type VOLTAGEValues = ValueOf<typeof VOLTAGE>;
export type VOLTAGEKeys = keyof typeof VOLTAGE;